


























































import { Component, Vue } from 'vue-property-decorator'
import { State, Action } from 'vuex-class'

import { Location } from 'vue-router'

import {
  ListItem,
  MobileLayout,
  SkeletonBox,
  VxCard
} from '@/layouts/components'

import { Profile } from '@/models'

@Component({
  components: {
    ListItem,
    MobileLayout,
    SkeletonBox,
    VxCard
  }
})
export default class More extends Vue {
  links: { route: Location; icon: string; text: string }[] = [
    {
      route: { name: 'PaymentMethods' },
      icon: 'credit_card',
      text: 'Meios de Pagamento'
    },
    {
      route: { name: 'OrderPayments' },
      icon: 'money',
      text: 'Pagamentos'
    },
    {
      route: { name: 'QrCodes' },
      icon: 'memory',
      text: 'QR codes'
    },
    {
      route: { name: 'DeliverySettings' },
      icon: 'local_shipping',
      text: 'Delivery'
    },
    {
      route: { name: 'Settings' },
      icon: 'settings',
      text: 'Configurações'
    }
  ]

  @State
  readonly profile!: Profile | null

  @Action
  logout!: () => Promise<void>

  async handleLogout () {
    await this.logout()
  }
}
